import SayKitWeb from '@whitesharx/starfall-frontend-saykit-web';

import { downloadAds } from '~/src/services/adsense/utils';
import { ADS_EVENTS } from '../analytics/contants';
import { AbstractAnalytics } from '../analytics/type';
import AdBanner, { AdBannerProps } from '~/src/components/PageLayout/components/AdBanner';

const ERROR_TYPES = ['notReady', 'timeout', 'error', 'noAdPreloaded', 'frequencyCapped', 'ignored', 'other'];

const END_AD_NAMES = {
  'end-game': 'interstitial_endtraining',
};

const logReason = (reason: string) => console.log(`Could not initialize Google Ads due to this reason: ${reason}`);

class AdsenseOnboarding {
  public blocked: boolean | undefined;
  public adsensePromise: Promise<void> | undefined;

  constructor(private analytics: AbstractAnalytics) {}

  public load() {
    return downloadAds()
      .then(() => {
        this.blocked = this.checkIsBlocked();
      })
      .catch((e) => {
        this.analytics.sendEvent(ADS_EVENTS.interstitialFailed, { type: e.message, placement: 'ALL' });

        this.blocked = true;
        logReason(e.message);
      });
  }

  private checkIsBlocked() {
    if (typeof window === 'undefined') {
      logReason('window object is not defined, we are on server now');

      return true;
    }

    if (!('adsbygoogle' in window)) {
      logReason('"adsbygoogle" did not initialized, most likely request for Google Ads was blocked');

      return true;
    }

    // Some Ad Blockers override real adsbygoogle object
    const isAdsByGoogleReal =
      'loaded' in window.adsbygoogle &&
      Boolean(window.adsbygoogle.loaded) &&
      // eslint-disable-next-line no-prototype-builtins
      window.adsbygoogle.hasOwnProperty('onload');

    if (!isAdsByGoogleReal) {
      logReason(
        '"loaded" is not in "adsbygoogle" object or it\'s false, most likely Ad Blocker redirected the request'
      );

      return true;
    }

    if (!('adBreak' in window)) {
      logReason('"adBreak" function is not initialized, most likely request for Ad Breaks was blocked');

      return true;
    }

    return false;
  }

  public showInterstitial(name: keyof typeof END_AD_NAMES) {
    if (!this.blocked && !!window.adBreak) {
      window.adBreak({
        type: 'start',
        name: END_AD_NAMES[name],
        beforeAd: () => SayKitWeb.startBackgroundTime(),
        afterAd: () => SayKitWeb.finishBackgroundTime(),
        adBreakDone: (placementInfo) => {
          if (placementInfo.breakStatus === 'viewed') {
            this.analytics.sendEvent(ADS_EVENTS.showedInterstitial, {
              type: 'adsense',
              name: END_AD_NAMES[name],
            });
          }

          console.log('interstitial has done', placementInfo);

          if (ERROR_TYPES.includes(placementInfo.breakStatus)) {
            this.analytics.sendEvent(ADS_EVENTS.interstitialFailed, {
              placement: placementInfo.breakName,
              type: placementInfo.breakStatus,
            });
          }
        },
      });
    }
  }

  public renderBanner(props: AdBannerProps) {
    return <AdBanner {...props} />;
  }
}

export default AdsenseOnboarding;
